import React            from 'react';

class Base extends React.Component {
    constructor(props) {
        super(props);
        this.state = { };
    }

    createNumericPattern() {
        let p = this.props;
        if(p.type === 'number') {
            return p.isDecimal
                ? p.isNegative
                    ? `^\\-$|^[-]?(?![0]\\d{1})([0-9]\\d{0,9})(\\.[0-9]{0,${p.decimalDigit}})?$`
                    : `^(?![0]\\d{1})([0-9]\\d{0,9})(\\.[0-9]{0,${p.decimalDigit}})?$`
                : p.isNegative
                    ? `^\\-$|^[-]?(?![0]\\d{1})[0-9]\\d{0,${p.decimalDigit}}?$`
                    : /^(?![0]\d{1})[0-9]\d{0,99}?$/
        }
    }


    inputControl(e) {
        let p = this.props;

        if(p.type === 'number') {
            if(p.max && parseFloat(e.target.value) > p.max)
                return false;

            if(p.min && parseFloat(e.target.value) < p.min)
                return false;
        }
        let pattern = p.type === 'number'
                        ? this.createNumericPattern()
                        : p.pattern;

        if(pattern && String(e.target.value).length > 0) {
            let patternTest = new RegExp(pattern);
            if(!patternTest.test(e.target.value))
                return false;
        }
        p.onChange(e);
    }

    render(){
        let p = this.props;
        return (
            <input 
                type            = { p.type === 'number' ? 'text' : p.type }
                className       = { `marketkit-textfield-input${ p.className ? ' ' + p.className : '' }`} 
                value           = { p.value || p.value === 0 ? p.value.toString() : '' }
                tabIndex        = { p.tabIndex }
                onChange        = { (e) => this.inputControl(e) }
                onClick         = { p.onClick }
                onFocus         = { p.onFocus }
                onBlur          = { p.onBlur }
                onKeyUp         = { p.onKeyUp }
                onKeyDown       = { p.onKeyDown }
                onSelect        = { p.onSelect }
                placeholder     = { p.placeholder || '' }
                ref             = 'INPUT'
                disabled        = { p.isDisabled }
                maxLength       = { p.maxLength }
                minLength       = { p.minLength }
                required        = { p.required }
                autoComplete    = { p.autoComplete ? 'off' : 'chrome-off'}
                max             = { p.max }
                min             = { p.min }
                { ...p.attrs }
            />
        )
    }
}

export default Base;